import { AlertTriangle } from 'lucide-react';

export default function EditRoleLoadErrorBanner({ message }: { message: string }) {
  return (
    <div className="mx-[22px] my-4 flex gap-2 items-start text-[12px] text-clay-800 dark:text-clay-300 bg-clay-50 dark:bg-clay-900/20 border border-clay-200 dark:border-clay-800 rounded-lg px-3 py-2.5">
      <AlertTriangle size={14} className="flex-none mt-0.5" />
      <span>Couldn&apos;t load this user: {message}</span>
    </div>
  );
}
